import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uicore"
    }}>{`@theme-ui/core`}</h1>
    <p><a parentName="p" {...{
        "href": "https://bundlephobia.com/package/@theme-ui/core"
      }}><img parentName="a" {...{
          "src": "https://badgen.net/bundlephobia/minzip/@theme-ui/core",
          "alt": "Minified Size on Bundlephobia"
        }}></img></a></p>
    <p><inlineCode parentName="p">{`@theme-ui/core`}</inlineCode>{` provides minimal React support for lightweight usage.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/core @emotion/react
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`/** @jsxImportSource @theme-ui/core */

import { ThemeProvider } from '@theme-ui/core'

export function App() {
  return (
    <ThemeProvider theme={{ colors: { primary: '#33e' } }}>
      <h1 sx={{ color: 'primary' }}>Hello</h1>
    </ThemeProvider>
  )
}
`}</code></pre>
    <p>{`If you already use `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` package, the batteries-included version of Theme
UI, you don't need to install `}<inlineCode parentName="p">{`@theme-ui/core`}</inlineCode>{` separately — it's already in your
node_modules, and `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` reexports everything from it.`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`jsx`}</inlineCode>{` — JSX function to create React elements supporting `}<inlineCode parentName="li">{`sx`}</inlineCode>{` prop`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ThemeProvider`}</inlineCode>{` — a `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/context.html"
        }}>{`context provider`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`useThemeUI`}</inlineCode>{` — a hook to access your theme`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`merge`}</inlineCode>{` — an utility function to deeply merge themes together`}</li>
    </ul>
    <h2 {...{
      "id": "jsx-runtime"
    }}>{`JSX Runtime`}</h2>
    <p>{`As `}<inlineCode parentName="p">{`@theme-ui/core`}</inlineCode>{` defines `}<inlineCode parentName="p">{`jsx`}</inlineCode>{` function and types for it, you can use it to
configure JSX runtime without installing `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` package.`}</p>
    <h3 {...{
      "id": "entry-point-jsx-runtime"
    }}>{`Entry point `}<inlineCode parentName="h3">{`/jsx-runtime`}</inlineCode></h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`jsxs`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "entry-point-jsx-dev-runtime"
    }}>{`Entry point `}<inlineCode parentName="h3">{`/jsx-dev-runtime`}</inlineCode></h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`jsxDEV`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      